import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import axios from "axios";

export type TInvoice = {
  date: string;
  amount_paid: number;
  currency: string;
  invoice_type: string;
  status: string;
  download_url: string;
};

interface GetUserInvoicesOption {
  token: string;
}

type TResponse = TCloudAPIResponse<TInvoice[]>;

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/user/invoices`;

export async function getUserInvoices(
  option: GetUserInvoicesOption,
): Promise<TResponse> {
  try {
    const response = await axios.get(APIURL, {
      headers: {
        Authorization: option.token,
      },
    });

    return response.data as TResponse;
  } catch (error: any) {
    console.error("Error fetching user invoices:", error);
    throw error;
  }
}
